<template>
  <div>
    <PageHeader :items="items" />
    <validation-observer ref="simpleRules">
      <div class="card">
        <div class="card-body">
          <div class="row mb-2">
            <div class="col-md-4">
              <div class="form-group">
                <label class="input-label form-label"
                  >{{ $t("firstName") }}
                </label>
                <input
                  id="firstName"
                  v-model="form.firstName"
                  name="title"
                  class="form-control"
                  type="text"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="input-label form-label" for="cars">{{
                  $t("lastName")
                }}</label>
                <input
                  id="lastName"
                  v-model="form.lastName"
                  name="title"
                  class="form-control"
                  type="text"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="input-label form-label"
                  >{{ $t("email") }}&nbsp;<span style="color: red">*</span>
                </label>
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required"
                >
                  <input
                    id="email"
                    v-model="form.email"
                    name="title"
                    class="form-control"
                    type="text"
                    :class="{ 'is-invalid': errors[0] }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-4">
              <div class="form-group">
                <label class="input-label form-label" for="cars">{{
                  $t("city")
                }}</label>
                <input
                  id="title"
                  v-model="form.city"
                  name="title"
                  class="form-control"
                  type="text"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="input-label form-label" for="cars">{{
                  $t("street")
                }}</label>

                <input
                  id="street"
                  v-model="form.street"
                  name="street"
                  class="form-control"
                  type="text"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="input-label form-label" for="cars">{{
                  $t("streetNumber")
                }}</label>
                <input
                  id="streetNumber"
                  v-model="form.streetNumber"
                  name="streetNumber"
                  class="form-control"
                  type="text"
                />
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-3">
              <div class="form-group">
                <label class="input-label form-label" for="cars">{{
                  $t("zip")
                }}</label>
                <input
                  id="zip"
                  v-model="form.zip"
                  name="zip"
                  class="form-control"
                  type="text"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label class="input-label form-label" for="cars">{{
                  $t("mobile")
                }}</label>
                <input
                  id="mobile"
                  v-model="form.mobile"
                  name="mobile"
                  class="form-control"
                  type="text"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label class="input-label form-label" for="cars">{{
                  $t("phone")
                }}</label>
                <input
                  id="phoneNo"
                  v-model="form.phoneNo"
                  name="phoneNo"
                  class="form-control"
                  type="text"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label class="input-label form-label"
                  >{{ $t("contactLanguage") }}
                </label>
                <select
                  class="form-control"
                  v-model="form.contactLanguage"
                >
                  <option
                    v-for="language in languages"
                    :value="language.code"
                    :key="language.code"
                  >
                    {{ language.label }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-4">
              <div class="form-group">
                <label class="input-label form-label" for="cars">{{
                  $t("roles")
                }}</label>
                <multiselect
                  v-model="form.roles"
                  label="title"
                  :multiple="true"
                  track-by="id"
                  :options="roles"
                  selectLabel=""
                  deselectLabel=""
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="input-label form-label" for="cars"><span style="color: red">*</span>&nbsp;{{
                  $t("company")
                }}</label>
                 <validation-provider
                  #default="{ errors }"
                  name="Company"
                  rules="required"
                >
                <MultiSelectInput
                  v-model="form.company_id"
                  :options="customers"
                  :query="{ isMultiSelect: true }"
                  label="companyName"
                  trackBy="id"
                  :key="form.company_id"
                  moduleName="customers"
                  :multiple="false"
                  ><template #option="{ props }">
                    <div>
                      <p>
                        {{ props.option.companyNumber }} -
                        {{ props.option.companyName }}
                      </p>
                    </div>
                  </template>
                </MultiSelectInput>
                <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="input-label form-label" for="cars">{{
                  $t("types")
                }}</label>
                <multiselect
                  v-model="form.types"
                  :multiple="true"
                  :options="types"
                  selectLabel=""
                  deselectLabel=""
                />
              </div>
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-md-4">
              <div class="d-flex align-items-center gap-1">
                <div class="form-group w-100">
                  <label class="input-label form-label"
                    >{{ $t("password") }}&nbsp;<span style="color: red">*</span>
                  </label>
                  <validation-provider
                    #default="{ errors }"
                    name="Password"
                    rules="required"
                  >
                    <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                    >
                      <b-form-input
                        id="new-password"
                        v-model="form.password"
                        :state="errors.length > 0 ? false : null"
                        class="form-control-merge"
                        :type="passwordFieldType"
                        autocomplete="new-password"
                        name="new-password"
                        placeholder="············"
                        :class="{ 'is-invalid': errors[0] }"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          class="cursor-pointer"
                          :icon="passwordToggleIcon"
                          @click="togglePasswordVisibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <!-- <input
                      id="password"
                      v-model="form.password"
                      name="title"
                      class="form-control"
                      type="password"
                    /> -->
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>

                <feather-icon
                  @click="generatePassword"
                  class="cursor-pointer mt-2"
                  icon="RefreshCwIcon"
                  size="16"
                />
              </div>
              <ul class="list-unstyled text-muted medium mt-1">
                <li :class="{ 'text-success': hasNumber }">
                  ✔ At least 1 numeric
                </li>
                <li :class="{ 'text-success': hasUppercase }">
                  ✔ At least one capital letter
                </li>
                <li :class="{ 'text-success': hasSpecialChar }">
                  ✔ At least one special character
                </li>
                <li :class="{ 'text-success': hasValidLength }">
                  ✔ 8 characters
                </li>
              </ul>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="input-label form-label"
                  >{{ $t("confirmPassword") }}&nbsp;<span style="color: red"
                    >*</span
                  >
                </label>
                <validation-provider
                  #default="{ errors }"
                  name="Confirm Password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="new-password"
                      v-model="form.confirmPassword"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      autocomplete="new-password"
                      name="new-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <!-- <input
                    id="confirmPassword"
                    v-model="form.confirmPassword"
                    name="title"
                    class="form-control"
                    type="password"
                  /> -->
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
                <div v-if="!passwordsMatch" style="color: red">
                  {{ $t("passwordAndConfirmPasswordShouldBeMatched") }}
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group mt-1">
                <label class="input-label form-label" for="active">{{
                  $t("active")
                }}</label>

                <input
                  id="active"
                  class="form-check-input-custom ml-2"
                  v-model="form.status"
                  type="checkbox"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </validation-observer>
    <div class="d-flex justify-content-end">
      <div class="mt-2 max-w-3xl flex">
        <b-button
          @click="createUser()"
          class="mb-2 cursor-pointer"
          :disabled="isFormInvalid"
        >
          <span class="mr-25 align-middle">{{ $t("createUser") }}</span>
          <feather-icon icon="PlusIcon" size="12" />
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import TextInput from "@/components/TextInput.vue";
import PageHeader from "@/components/PageHeader.vue";
import Multiselect from "vue-multiselect";
import { mapGetters } from "vuex";
import MultiSelectInput from "@/components/MultiSelectInput.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import formDirtyMixin from "@/mixins/formDirtyMixin";
export default {
  components: {
    TextInput,
    PageHeader,
    Multiselect,
    MultiSelectInput,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility, formDirtyMixin],

  watch: {
    form: {
      handler(newVal) {
        this.isFormDirty = JSON.stringify(newVal) !== this.originalForm;
      },
      deep: true,
    },
  },

  mounted() {
    this.originalForm = JSON.stringify(this.form);
  },
  data() {
    return {
      originalForm: null,
      submitted: false,
      form: {
        firstName: "",
        lastName: "",
        email: "",
        city: "",
        street: "",
        streetNumber: "",
        zip: "",
        mobile: "",
        phoneNo: "",
        roles: [],
        types: ["employee"],
        password: "",
        confirmPassword: "",
        company_id: "",
        status: true,
        contactLanguage: "",
      },
      types: ["customer_employee", "employee", "partner"],
      languages: [
        { code: "en", label: "English" },
        { code: "de", label: "German" },
        { code: "fr", label: "French" },
        { code: "es", label: "Spanish" },
        { code: "tr", label: "Turkish" },
      ],
      passwordsMatch: true,
    };
  },
  computed: {
    ...mapGetters("roles", ["roles"]),
    ...mapGetters("customers", ["customers"]),
    hasNumber() {
      return /\d/.test(this.form.password);
    },
    hasUppercase() {
      return /[A-Z]/.test(this.form.password);
    },
    hasSpecialChar() {
      return /[^a-zA-Z0-9]/.test(this.form.password);
    },
    hasValidLength() {
      return this.form.password.length >= 8;
    },
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    isPasswordValid() {
      return (
        this.hasNumber &&
        this.hasUppercase &&
        this.hasSpecialChar &&
        this.hasValidLength
      );
    },
    items() {
      return [
        {
          text: this.$t("dentalTwin"),
          to: "/home",
        },
        {
          text: this.$t("users"),
          to: "/users",
        },
        {
          text: this.$t("create"),
          active: true,
        },
      ];
    },
    isFormInvalid() {
      return (
        !this.form.email ||
        !this.form.password ||
        !this.form.confirmPassword ||
        !this.isPasswordValid ||
        !this.form.company_id
      );
    },
  },
  async created() {
    try {
      this.$store.commit("showLoader", true);
      await this.$store.dispatch("roles/list", {
        limit_start: 0,
        limit_count: 100,
      });
      await this.$store.dispatch("customers/list", { isMultiSelect: true });

      const companyId = this.$route.query.companyId;
      if (companyId) {
        const res = await this.$store.dispatch("customers/show", companyId);
        this.form.company_id = res?.data?.modelData ?? "";
      }
    } catch (e) {
      console.error("api error ___", e);
    } finally {
      this.$store.commit("showLoader", false);
    }
  },

  methods: {
    generatePassword() {
      const numbers = "0123456789";
      const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const lowercase = "abcdefghijklmnopqrstuvwxyz";
      const specialChars = "!@#$%^&*()_+-=[]{}|;:,.<>?";
      const allChars = numbers + uppercase + lowercase + specialChars;

      // Ensure each requirement is met at least once
      let password = "";
      password += numbers[Math.floor(Math.random() * numbers.length)];
      password += uppercase[Math.floor(Math.random() * uppercase.length)];
      password += specialChars[Math.floor(Math.random() * specialChars.length)];

      // Fill remaining characters
      while (password.length < 8) {
        password += allChars[Math.floor(Math.random() * allChars.length)];
      }

      // Shuffle password characters for randomness
      password = password
        .split("")
        .sort(() => 0.5 - Math.random())
        .join("");

      // Set password to form model (assuming form.password is your v-model)
      this.form.password = password;
      this.form.confirmPassword = password;
    },
    async createUser() {
      try {
        this.$refs.simpleRules.validate().then(async (success) => {
          if (success) {
            this.passwordsMatch = true;
            this.submitted = true;
            if (!this.isPasswordValid) {
              return;
            }
            if (this.form.password !== this.form.confirmPassword) {
              this.passwordsMatch = false;
            } else {
              this.$store.commit("showLoader", true);
              this.passwordsMatch = true;
              const response = await this.$store.dispatch("users/create", {
                first_name: this.form.firstName,
                last_name: this.form.lastName,
                mail: this.form.email,
                city: this.form.city,
                street: this.form.street,
                street_number: this.form.streetNumber,
                zip: this.form.zip,
                mobile: this.form.mobile,
                phone: this.form.phoneNo,
                company_id: this.form.company_id?.id ?? "",
                set_company_id: this.form.company_id?.id ?? "",
                password: this.form.password,
                types: this.form.types,
                status: this.form.status ? 1 : 0,
                contact_language: this.form.contactLanguage,
                roles:
                  this.form.roles && this.form.roles.length
                    ? this.form.roles.map((role) => role.id)
                    : [],
              });
              if (
                response.hasOwnProperty("message_type") &&
                response.message_type == "error"
              ) {
              } else {
                this.isFormDirty = false;
                this.originalForm = JSON.stringify(this.form);

                const companyId = this.$route.query.companyId;

                if (companyId) {
                  await this.$router.replace({
                    path: `/customers/${companyId}/edit`,
                  });
                } else {
                  await this.$router.replace({ path: "/users" });
                }
              }
            }
          }
        });
      } catch (e) {
        console.error("api error ___", e);
      } finally {
        this.$store.commit("showLoader", false);
      }
    },
  },
};
</script>

<style>
#nprogress {
  position: relative;
  z-index: 9999999;
}

.white-color {
  color: white !important;
}

.vgt-responsive {
  overflow-x: visible !important;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
